import './App.css';
import { Navbar, ContactMe, Home, About, Portfolio } from './components';


function App() {
  return (
    <div className="App">
      <Navbar />
      <h1 id='my-name'>Anthony Penaloza</h1>
      <Home />
      <About />
      <Portfolio />
      <ContactMe />
    </div>
  );
}

export default App;
